import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { BoardingPlaceTemplate } from '../Types/boardingPlaceTemplatesTypes';

export const boardingPlaceTemplatesApi = createGenericApiSlice<BoardingPlaceTemplate>({
  reducerPath: 'boardingPlaceTemplatesApi',
  tag: TagTypes.BoardingPlaceTemplate,
  endpoint: 'boarding-place-template',
});

export const {
  useGetAllQuery: useGetBoardingPlaceTemplatesQuery,
  useGetByIdQuery: useGetBoardingPlaceTemplateByIdQuery,
  useCreateMutation: useCreateBoardingPlaceTemplateMutation,
  useUpdateMutation: useUpdateBoardingPlaceTemplateMutation,
  useDeleteMutation: useDeleteBoardingPlaceTemplateMutation,
} = boardingPlaceTemplatesApi;
